import { API_URL, getAuthHeaders } from '../api';

export interface Court {
    id: string;
    club_id: string;
    name: string;
    type: 'indoor' | 'outdoor';
    subtype: 'single' | 'double';
    surface: 'synthetic_grass' | 'sand' | 'full_scenic' | 'other';
    features: {
        cameras?: boolean;
        scoreboard?: boolean;
        heating?: boolean;
        structure?: 'classic' | 'panoramic' | 'full_panoramic';
        [key: string]: any;
    };
    status: 'active' | 'maintenance' | 'reserved_lessons';
    allow_online_booking: boolean;
    // Positioning
    position_x?: number;
    position_y?: number;
    width?: number;
    height?: number;
    rotation?: number;
    photo_url?: string;
}

export const courtsService = {
    // ... (previous methods)

    batchUpdateLayout: async (courts: Partial<Court>[]): Promise<void> => {
        const res = await fetch(`${API_URL}/manager/courts/layout`, {
            method: 'POST',
            headers: {
                ...getAuthHeaders(),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(courts)
        });
        if (!res.ok) throw new Error('Failed to update layout');
    },

    // Public: List courts for a club
    listByClub: async (clubId: string): Promise<Court[]> => {
        const res = await fetch(`${API_URL}/clubs/${clubId}/courts`);
        const data = await res.json();
        return Array.isArray(data) ? data : [];
    },

    // Manager: Create Court
    create: async (data: Partial<Court>): Promise<Court> => {
        const url = `${API_URL}/manager/courts`;
        console.log("Creating Court:", url, data);
        // alert(`DEBUG: Posting to ${url}`); // Cleanup
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                ...getAuthHeaders(),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        if (!res.ok) {
            const txt = await res.text();
            console.error("Court Create Failed:", res.status, txt);
            // alert(`Error ${res.status}: ${txt}`);
            throw new Error(`Failed to create court: ${res.status}`);
        }
        const json = await res.json();
        return json;
    },

    // Manager: Update Court
    update: async (id: string, data: Partial<Court>): Promise<Court> => {
        const res = await fetch(`${API_URL}/manager/courts/${id}`, {
            method: 'PUT',
            headers: {
                ...getAuthHeaders(),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        if (!res.ok) {
            const txt = await res.text();
            console.error("Court Update Failed:", res.status, txt);
            throw new Error(`Failed to update court: ${txt}`);
        }
        const json = await res.json();
        return json;
    },

    // Manager: Delete Court
    delete: async (id: string): Promise<void> => {
        const res = await fetch(`${API_URL}/manager/courts/${id}`, {
            method: 'DELETE',
            headers: getAuthHeaders()
        });
        if (!res.ok) throw new Error('Failed to delete court');
    },

    // Public: Court TV State
    getTVState: async (id: string): Promise<{ state: 'live' | 'next' | 'idle', data: any, court?: { id: string; name: string }, club?: { name: string, logo_url?: string } }> => {
        const res = await fetch(`${API_URL}/public/courts/${id}/tv-state?t=${Date.now()}`);
        if (!res.ok) throw new Error('Failed to fetch TV state');
        return await res.json();
    }
};
